import { Box } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

const WhatsAppButton = ({ title, link }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 1,
        margin: "20px auto",
        fontSize: "18px",
        fontWeight: 600,
        width: "100%",
        borderRadius: "20px",
        backgroundColor: "#24D366",
      }}
    >
      <WhatsAppIcon sx={{ marginRight: 1, color: "#fff" }} fontSize="large" />
      <a
        href={link}
        target="_blank"
        rel="noreferrer"
        style={{ color: "#fff", textDecoration: "none" }}
      >
        {title}
      </a>
    </Box>
  );
};

export default WhatsAppButton;
